import { useContext, useState } from 'react'
import { useParams } from 'react-router-dom'

import Button from 'react-bootstrap/Button'

import UserContext from '../../context/User/User'
import { ORGANIZATION_PERMISSION_SLUGS } from '@blocktickets/shared-utils'
import { exportEventPurchasers } from '../../utilities/api'
import { checkPermission } from '../../utilities/helpers'
import AuthService from '../../utilities/services/auth.service'
import { NoPermissionsContainer } from '../NoPermissionsContainer'
import { PageLoadingContainer } from '../PageLoadingContainer'

function filenameFromDisposition(header) {
  const match = /filename="([^"]+)"/.exec(header || '')
  return match?.[1] || 'purchasers.csv'
}

export default function PurchaserExportWrapper() {
  const { uuid } = useParams()
  const { orgPermissions } = useContext(UserContext)
  const { getPermissions, isSuperAdminOrganizer } = AuthService
  const isSuperAdmin = isSuperAdminOrganizer()
  const orgPermissionsReady = isSuperAdmin || orgPermissions?.length > 0
  const hasPermission =
    isSuperAdmin ||
    (orgPermissionsReady &&
      checkPermission(
        getPermissions(),
        ORGANIZATION_PERMISSION_SLUGS.EVENT_MANAGEMENT
      ))

  const [exporting, setExporting] = useState(false)
  const [error, setError] = useState('')

  const downloadExport = async () => {
    setExporting(true)
    setError('')
    try {
      const response = await exportEventPurchasers(uuid)
      const url = window.URL.createObjectURL(response.data)
      const link = document.createElement('a')
      link.href = url
      link.download = filenameFromDisposition(
        response.headers?.['content-disposition']
      )
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)
    } catch (downloadError) {
      setError('The purchaser export could not be downloaded.')
    } finally {
      setExporting(false)
    }
  }

  if (!orgPermissionsReady) {
    return <PageLoadingContainer />
  }

  if (!hasPermission) {
    return <NoPermissionsContainer />
  }

  return (
    <section className="max-width-wrapper" data-testid="purchaser-export">
      <header className="section-header">
        <div className="section-heading">
          <h1>Purchaser export</h1>
        </div>
        <p className="section-header-desc">
          Download the name, email, mailing address, product, and seat for each
          ticket sold for this event, including complimentary tickets. The
          product is the package or offer name when one is available. Each seat
          is its own row.
        </p>
      </header>
      <Button onClick={downloadExport} disabled={exporting}>
        {exporting ? 'Exporting...' : 'Export purchasers'}
      </Button>
      {error ? <p className="text-danger mt-3 mb-0">{error}</p> : null}
    </section>
  )
}
